<template>
  <div>
    <i-button
      data-testid="webhook-test-button"
      icon
      icon-symbol="medium-alert-alarm-bell"
      text="Test"
      :disabled="disabled"
      type="neutral"
      subtype="subtle"
      size="lg"
      class="i-ml-6"
      @button-click="openTestModal"
    ></i-button>

    <i-modal
      modal-id="edit-webhook"
      data-testid="test-webhook-modal"
      title="Test Webhook"
      confirm-button-text="Test Webhook"
      type="primary"
      @on-submit="testWebhook"
    >
      <div slot="body-content">
        <h5 class="i-text-body-2 i-text-neutral-110 i-mb-0">
          Call the webhook
          <strong class="webhook-url">‘{{ webhook.url }}’</strong> with an
          example payload. <br />This may have unintended consequences in a
          production environment. <br />
          <br />For help distinguishing payloads, please see our
          <a
            rel="noopener"
            href="https://docs.inscribe.ai/reference/addwebhook"
            target="_blank"
            class="i-link"
            tabindex="0"
            >documentation.</a
          >
        </h5>
      </div>
    </i-modal>
  </div>
</template>

<script>
import { iButton, iModal, openModal } from '@inscribe/signal';
import { mapGetters } from 'vuex';

export default {
  components: {
    iButton,
    iModal,
  },
  props: {
    webhook: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
  methods: {
    openTestModal() {
      openModal('edit-webhook');
      this.$emit('flow-start');
    },
    async testWebhook() {
      try {
        const resp = await this.$store.dispatch('testWebhook', {
          id: this.webhook.id,
        });
        const webhookStatus = `Webhook responded ${resp.data.webhook_status_code}: ${resp.data.webhook_reason}`;
        if (!resp.data?.success) {
          this.$emit('on-status', resp.data?.error || webhookStatus, 'error');
        } else {
          this.$emit('on-status', webhookStatus, 'success');
        }
      } catch (err) {
        this.$emit('on-status', err.data?.error, 'error');
      }
    },
  },
};
</script>
<style scoped>
.webhook-url {
  overflow-wrap: break-word;
  word-break: break-all;
}
</style>
